import React, { useState, useCallback, useEffect } from "react";
import {AppMenu} from "./AppMenu";


interface CareersProps {}

interface CareersState {}

const Careers: React.FC<CareersProps> = ({}) => {           
    const [pageState, setPageState] = useState<CareersState>(() => {});

    return(
        <>
                    <div style={{width: "100%", textAlign: "left"}}>
                        <AppMenu/>
                    </div>
                    <div key={'PS7'} style={{ 
                    flex: '1 0 calc(100% - 40px)',
                    minWidth: '250px',
                    minHeight: '590px',
                    background: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}>
                    <div style={{ 
                      padding: '15px', 
                      borderBottom: '0px solid #e1e1e1',
                      background: '#ffffff',
                      fontWeight: 600,
                      color: '#323130'
                    }}>
                      Careers
                    </div>
                    <div style={{ flex: '1 0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                       <div className="card-full-grey">         
                        <div style={{fontSize: '0.90rem', color: '#4a4a4a;'}}>eSDXG is looking for talented and motivated individuals who are passionate about technology, innovation, and customer success. We offer dynamic and collaborative roles where you can shape your skills and grow your career. Current openings are listed below.
                <h3 style={{color: 'blue', fontStyle: 'italic', fontSize: '0.90rem'}}>Send your resume to careers@esdxg.com.</h3>                </div>
                <ul className="card-list-grey" style={{fontSize: "0.75rem"}}>                  
                  <li key="Role1">
                      Role: Business System Associate - Software Development<br/>                      
                      Experience: 2 - 5 years<br/>                      
                      Education: BTech / MCA / BCA / Degree with Diploma in Computer application<br/>
                      Technical skills: Python / C#.Net, SQL, HTML, CSS, Javascript / Typescript, SQL & No SQL                     
                  </li>
                   <li key="Role2">
                      Role: Business System Associate - System Administration<br/>                      
                      Experience: 2 - 5 years<br/>                      
                      Education: BTech / MCA / BCA / Degree with Diploma in Computer application<br/>
                      Technical skills: Windows / Linux, Networking, Cloud (Azure / AWS / GCP), Microsoft 365, Dev-Ops
                  </li>
                  <li key="Role3">
                      Role: Business Process Associate - Finance<br/>                      
                      Experience: 2 - 5 years<br/>                      
                      Education: CA / MBA-Finance / MCom<br/>
                      Customer oriented with attention to details, good presentation and communication skills.
                  </li>
                  <li key="Role4">
                      Role: Business Process Associate - Supply Chain<br/>                      
                      Experience: 2 - 5 years<br/>                      
                      Education: Degree + Certificate in Operations / Supply Chain / Logistics & Transportation<br/>
                      Customer oriented with attention to details, good presentation and communication skills.
                  </li>
                </ul>
                <i><u>* Freshers will be considered for trainee positions.</u></i>              
                      </div>
                    </div>
                  </div>
                </>
    );
}

export default Careers; 
